import React from 'react';
import PropTypes from 'prop-types';

export default function LoadCaseDetailsFailedAlert({ isTransferredToCwnrs }) {
  return (
    <div className="vads-u-margin-y--3">
      <va-alert
        close-btn-aria-label="Close notification"
        status="error"
        visible
      >
        {isTransferredToCwnrs ? (
          <>
            <h2 slot="headline">
              We can't show your VR&E benefits status right now
            </h2>
            <p>
              We're migrating VR&E benefits to a new case management system.
              During this time, you may not be able to review your benefits
              status.
            </p>
            <p>
              If you have questions, call us at{' '}
              <va-telephone contact="8008271000" />;{' '}
              <va-telephone contact="711" tty />, or contact your counselor.
            </p>
          </>
        ) : (
          <>
            <h2 slot="headline">We can't load the Case Progress right now</h2>
            <p>
              Something went wrong. If the issue persists, contact the VA
              benefits hotline.
            </p>
          </>
        )}
      </va-alert>
    </div>
  );
}

LoadCaseDetailsFailedAlert.propTypes = {
  isTransferredToCwnrs: PropTypes.bool,
};
